














import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import { InstituteInfo } from "../../_models/instituteInfo";
import { UserInfo } from "../../_models/userInfo";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import * as temp from "../../_store/temp.module"

@Component({
	components: {
		CardTitle,
		DetailsDataTable
	}
})
export default class GestioneAlternanzaTutor extends Vue {
	private titleParams: object;
	private dataTableParams: any;
	private createDialogParams: object;
	private reportDataTableParams: any;
	private createReportDialogParams: object;

	private listaPreAssegnazioni: any;

	constructor() {
		super();
		this.titleParams = {
			title: "FSL Estiva",
			cols: "10",
			sm: "5",
			md: "5",
			lg: "4"
		};
		this.dataTableParams = {
			headers: [
				{
					text: "Allievo",
					value: "allievo"
				},
				{
					text: "Classe",
					value: "classe",
					width: "1%"
				},
				{
					text: "Azienda",
					value: "denominazioneAzienda"
				},
				{
					text: "Data Inizio",
					value: "dataInizioPeriodo"
				},
				{
					text: "Data Fine",
					value: "dataFinePeriodo"
				},
				{
					text: "Dettagli Allievo",
					value: "action",
					sortable: false,
					width: "1%"
				},
				{
					text: "Dettagli FSL",
					value: "dettagliAlternanza",
					sortable: false,
					width: "1%"
				},
				{
					text: "Conferma",
					value: "confermaAlternanza",
					sortable: false,
					width: "1%"
				},
				{
					text: "Conv.",
					value: "statusDocConvenzione",
					sortable: false,
					width: "1%"
				},
				// {
				//   text: "Patto Formativo",
				//   value: "statusDocPattoFormativo",
				//   sortable: false,
				//   width: '1%'
				// },
				{
					text: "Progetto Formativo",
					value: "statusDocPercorsoFormativo",
					sortable: false,
					width: '1%'
				},
				{
					text: "Attestato Finale",
					value: "statusDocAttestatoFinale",
					sortable: false,
					width: '1%'
				},
				{
					text: "Foglio Firme",
					value: "starusDocFoglioFirme",
					sortable: false,
					width: "1%"
				},
				{
					text: "Quest. Allievo",
					value: "statusDocQuestionarioTir",
					sortable: false,
					width: '1%'
				},
				{
					text: "Quest. Azienda",
					value: "statusDocQuestionarioAz",
					sortable: false,
					width: '1%'
				},
				{
					text: "Report Visita",
					value: "reportVisiteTirEstivo",
					sortable: false,
					width: '1%'
				},
				// {
				//   text: "Report Visita",
				//   value: "reportVisiteTirEstivo",
				//   sortable: false,
				//   width: '1%'
				// },
				{
					text: "Doc",
					value: "dettagliDocAlternanza",
					sortable: false,
					width: '1%'
				},
			],
			records: [],
			dialogParams: {
				title: "DETTAGLI ALLIEVO",
				type: "userTab"
			},
			filterType: "listaAbbinamenti",
			alternanzaDialogParams: {
				title: "DETTAGLI FSL",
				type: "infoAlternanzaTab"
			},
			type: "alternanza"
		};

		this.reportDataTableParams = {
			headers: [
				{
					text: "Data Visita",
					value: "dataVisita"
				},
				{
					text: "Ora Visita",
					value: "oraVisita"
				},
				{
					text: "Dettagli Report",
					value: "dettagliReportTirEstivo"
				},
				{
					text: "Confermato",
					value: "statusReport"
				}
			],
			records: [],
			compileDialogParams: {
				title: "REPORT VISITA",
				type: "reportVisita"
			},
			detailsDialogParams: {
				title: "DETTAGLI REPORT VISITA",
				type: "reportVisita"
			},
			activityType: "alternanza"
		};
		this.createReportDialogParams = {
			visible: false,
			type: "nuovoReportVisita"
		};
		this.createDialogParams = {
			visible: false,
			type: ""
		};
		this.listaPreAssegnazioni = [];
	}

	loadPreAssegnazioni(idAnnoScolastico: number) {
		var instituteInfo: InstituteInfo = user.readInstituteInfo(this["$store"]);
		var userInfo: UserInfo = user.readUserInfo(this["$store"]);
		var payload = {
			idIstituto: instituteInfo.id,
			idAnnoScolastico: idAnnoScolastico,
			idTutor: userInfo.idUtente
		};
		data
			.dispatchAllieviPreAssegnati(this["$store"], payload)
			.then(result => {
				this.listaPreAssegnazioni = result;
				this.dataTableParams.records = result;
				bus.$emit("dataLoaded");
			})
			.catch(error => {
				if (error.response.status === 403) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	created() {
		var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
		var token = localStorage.getItem("userToken");
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		user
			.dispatchSetUserInfo(this["$store"], payload)
			.then(() => {

				const utente = user.readUserInfo(this["$store"]);
				if (utente.ruoloUtente.includes(2) || utente.ruoloUtente.includes(10)) {
					this.dataTableParams.headers.push({
						text: "",
						value: "ratingAlternanza",
						sortable: false,
						width: "1%"
					});
				}

				if (utente.ruoloUtente.includes(2)) {
					this.dataTableParams.headers.push({
						text: "",
						value: "deleteAbbinamentoAlternanza",
						sortable: false,
						width: "1%"
					});
				}

				user
					.dispatchSetInstituteInfo(this["$store"])
					.then(() => {
						this.loadPreAssegnazioni(idAnnoScolastico);
						bus.$emit("loadMenu");
					})
					.catch(() => {
						bus.$emit("stopLoading");
						auth.dispatchLogout(this["$store"]);
						user.dispatchClearState(this["$store"]);
						this["$router"].push("/sessionExpired");
					});
			})
			.catch(() => {
				bus.$emit("stopLoading");
				auth.dispatchLogout(this["$store"]);
				user.dispatchClearState(this["$store"]);
				this["$router"].push("/sessionExpired");
			});

		bus.$on("loadPreAssegnazioni", () => {
			var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
			this.listaPreAssegnazioni = [];
			this.dataTableParams.records = [];
			this.loadPreAssegnazioni(idAnnoScolastico)
		})

		bus.$on("changeAnnoScolastico", (payload: any) => {
			this.loadPreAssegnazioni(payload)
		})

		bus.$on("filtroAbbinamenti", (filters: any) => {
			const listaAbbinamenti: any = this.listaPreAssegnazioni;
			var tempList: any = [];
			this.dataTableParams.records = [];
			listaAbbinamenti.forEach((abbinamento: any) => {
				if (filters.filtroStatusTirocinio !== "Tutti") {
					if (filters.filtroStatusTirocinio === "Accettati") {
						if (abbinamento.idStatoAccettazione == 2) {
							tempList.push(abbinamento);
						}
					} else if (filters.filtroStatusTirocinio === "Rifiutati") {
						if (abbinamento.idStatoAccettazione == 3) {
							tempList.push(abbinamento);
						}
					} else if (filters.filtroStatusTirocinio === "Terminati") {
						if (abbinamento.idStatoAccettazione == 4) {
							tempList.push(abbinamento);
						}
					} else if (filters.filtroStatusTirocinio === "Confermati") {
						if (abbinamento.idStatoAccettazione == 5) {
							tempList.push(abbinamento);
						}
					} else if (filters.filtroStatusTirocinio === "Annullati") {
						if (abbinamento.idStatoAccettazione == 7) {
							tempList.push(abbinamento);
						}
					}
				} else {
					tempList.push(abbinamento);
				}
			});
			this.dataTableParams.records = tempList;
		})
	}
}
